import React from 'react';

const Schools = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Nos écoles</h1>
        <p className="text-gray-600">Contenu de la page nos écoles...</p>
      </div>
    </div>
  );
};

export default Schools; 